/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMusicResource} from '../api'

 export const useQueryGetMusicResource = createReactQueryHook('getMusicResource', getMusicResource)
